import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TypeNumber from '../../../form/form-fields/TypeNumber';
import RemoveIcon from '@mui/icons-material/Remove';
import { useEffect, useState } from 'react';
import { FormFieldsHighlightContainer } from '../../../form/FormFieldsHighlightContainer';

export const MatchingPropLeadFieldNumber = ({
  property,
  onChange,
  required,
  size = 'small',
}) => {
  const { t } = useTranslation();

  const minValueField = {
    label: property.label + ` (${t('MIN')})`,
    key: 'minValue',
    unit: property.unit,
    decimalPlaces: property.decimalPlaces ?? 2,
    removeThousandSeparator: !property.thousandSeparator,
  };
  const maxValueField = {
    label: property.label + ` (${t('MAX')})`,
    key: 'maxValue',
    unit: property.unit,
    decimalPlaces: property.decimalPlaces ?? 2,
    removeThousandSeparator: !property.thousandSeparator,
  };

  function handleUpdate(key, value) {
    const newProp = { ...property, [key]: value };
    onChange(newProp);
  }

  return (
    <Box className="flex items-center gap-1 w-full">
      <Box className="w-full">
        <FormFieldsHighlightContainer
          error={!property.minValue}
          field={minValueField}
          hasValidation={true}
          hidden={required !== true}
        >
          <TypeNumber
            size={size}
            field={minValueField}
            dataCollection={property}
            updateValidationOnChange={handleUpdate}
          />
        </FormFieldsHighlightContainer>
      </Box>
      <RemoveIcon />
      <Box className="w-full">
        <FormFieldsHighlightContainer
          error={!property.maxValue}
          field={maxValueField}
          hasValidation={true}
          hidden={required !== true}
        >
          <TypeNumber
            size={size}
            field={maxValueField}
            dataCollection={property}
            updateValidationOnChange={handleUpdate}
          />
        </FormFieldsHighlightContainer>
      </Box>
    </Box>
  );
};
